import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b78178fa&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b78178fa')) {
      api.createRecord('b78178fa', component.options)
    } else {
      api.reload('b78178fa', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b78178fa&", function () {
      api.rerender('b78178fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/comp/FavElement.vue"
export default component.exports